<div class="product">
    <div class="info" (click)="product.showcomp=!product.showcomp" *ngIf="product.comp">
        <img src="assets/images/icons/info.png" alt="info">
    </div>
    <div class="flip-container" [class.flipped]="product.showcomp">
        <div class="flipper">
            <div easyzoom *ngIf="loadAvatar" class="main-img">
                <img [src]="product.avatar|absolutePath:'products'"
                    [alt]="'Livraison '+product.familyName+' '+product.name"
                    [title]="'Livraison '+product.familyName+' '+product.name" />
            </div>
            <div class="main-img" *ngIf="!loadAvatar">
                <div class="loading"></div>
                <img appLazyLoad (lodedImage)="loadAvatar=true" [src]="product.avatar|absolutePath:'products'"
                    [alt]="'Livraison '+product.familyName+' '+product.name"
                    [title]="'Livraison '+product.familyName+' '+product.name" />
            </div>
            <div class="compositions back" *ngIf="product.showcomp">
                <div>
                    <ul>
                        <li *ngFor="let comp of product.comp|toArray">
                            {{comp}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="product-body">
        <h2>{{product.name}}</h2>
        <div class="size" *ngIf="product.sizes.length>1 || (product.sizes.length==1 && product.sizes[0].level!=0)">
            <select *ngIf="product.sizes.length>1" class="form-control" [(ngModel)]="product.size">
                <option *ngFor="let s of product.sizes;let j=index" [value]="j">{{s.size}}</option>
            </select>
            <p *ngIf="product.sizes.length==1 && product.sizes[0].level!=0">{{product.sizes[0].size}}</p>
        </div>
    </div>
    <div class="product-footer">
        <ng-container *ngIf="product.validPeriod==1">
            <ng-container *ngIf="product.sizes[product.size]?.available">
                <div class="d-flex w-100 justify-content-between">
                    <button class="btn price cursor-pointer" (click)="addToBasket()" [disabled]="siteClose">
                        {{product.sizes[product.size].price| helpycurrency}}
                    </button>
                    <button class="btn personalize" aria-hidden="true" (click)="addToBasket()" [disabled]="siteClose">
                        <img src="assets/images/add.png" alt="" srcset="">
                    </button>
                </div>
            </ng-container>
            <ng-container *ngIf="!product.sizes[product.size]?.available">
                <button class="btn indisponible">
                    Indisponible pour le moment
                </button>
            </ng-container>
        </ng-container>
        <div class="action vcenter" *ngIf="product.validPeriod==0">
            <button class="btn indisponible" *ngIf="product.elementTime==1">Disponible midi uniquement</button>
            <button class="btn indisponible" *ngIf="product.elementTime==3">Disponible soir uniquement</button>
        </div>
    </div>
</div>